<template>
  <q-no-ssr>
    <MobileBottomPanel v-if="$q.screen.lt.lg"/>
    <Drawer/>
    <StickyOffers
        class="c-sticky-offers"
        :style="fortuneButtonStyle"
        v-if="stickyOffersEnable"
    />
  </q-no-ssr>
</template>

<script setup lang="ts">

import {QNoSsr, useQuasar} from "quasar";
import MobileBottomPanel from "./MobileBottomPanel.vue";
import Drawer from "@/layouts/ui/Drawer.vue";
import {computed} from "vue";
import {StyleValue} from "@vue/runtime-dom";
import {useLayoutStore} from "@/stores/layout";
import {storeToRefs} from "pinia";
import StickyOffers from "@/components/Offer/StickyOffers.vue";
import {useRouterStore} from "@/core/router/store";

const $q = useQuasar();

const layoutStore = useLayoutStore();
const {contentColumn} = storeToRefs(layoutStore);

const routerStore = useRouterStore();
const {routeMeta} = storeToRefs(routerStore);
const stickyOffersEnable = computed(() => !routeMeta.value.hideOffers);

const fortuneButtonStyle = computed(() => {
  const style: StyleValue = {}
  if ($q.screen.gt.md) {
    style.left = Math.round((contentColumn.value.left + contentColumn.value.width / 2)) + 'px'
    style.transform = "translateX(-50%)";
    style.bottom = '16px';
  } else {
    // На мобильных — по центру над bottom panel
    style.left = '50%';
    style.transform = 'translateX(-50%)';
    style.bottom = '54px'; // высота MobileBottomPanel + отступ
  }
  return style
})

</script>

<style scoped lang="scss">

.c-sticky-offers {
  position: fixed;
  z-index: 1000;
}
</style>
